import { ITableColumnSort } from '/shared/Table';

export function getSortMap<S extends string>(sortBy: ITableColumnSort<S>[]): Map<string, ITableColumnSort<S>> {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return sortBy.reduce(
    (acc: Map<string, ITableColumnSort<S>>, next: ITableColumnSort<S>) => acc.set(next.field?.toString(), next),
    new Map()
  );
}
